export default __webpack_public_path__ + "static/media/bmriidja-color.c951a1eb.svg";